import { render, staticRenderFns } from "./Environments.vue?vue&type=template&id=05cc5972&scoped=true&"
import script from "./Environments.vue?vue&type=script&lang=js&"
export * from "./Environments.vue?vue&type=script&lang=js&"
import style0 from "./Environments.vue?vue&type=style&index=0&id=05cc5972&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cc5972",
  null
  
)

export default component.exports